// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 792) return "main.2076d132.css";
	// return url for filenames based on template
	return "" + chunkId + "." + {"97":"897472ac","579":"290a3129","819":"cd3217d6"}[chunkId] + ".chunk.css";
};